module.exports = __webpack_public_path__ + "static/media/wally.7b41c1ad.svg";